import { useMemo } from "react";
export const useHasError = (meta, showErrorOnMount = false) => {
  let {
    submitError,
    dirtySinceLastSubmit,
    error,
    touched,
    modified
  } = meta;
  return useMemo(() => {
    let hasError = !!(submitError && !dirtySinceLastSubmit || error);
    let isTouched = touched || modified;

    if (showErrorOnMount) {
      return hasError;
    }

    return hasError && isTouched;
  }, [error, touched, modified, submitError, showErrorOnMount, dirtySinceLastSubmit]);
};